export const days = (() => {
  const out: Date[] = []
  const d = new Date()
  while (out.length < 5) {
    d.setDate(d.getDate() + 1)
    if (d.getDay() % 6 !== 0) out.push(new Date(d))
  }
  return out
})()

export const times = ["09:00", "10:00", "11:00", "14:00", "15:00", "16:00", "17:00"]

export const taken = (day: number, time: number) => (day * 7 + time * 3) % 5 === 0

export const dayLabel = (d: Date) => d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })
